import { create } from "zustand";
import { persist } from "zustand/middleware";

const DEFAULT_LEVERAGE = 5;

interface LeveragePreferencesState {
  // Map of "exchangeId:pairSymbol" to leverage number
  preferences: Record<string, number>;

  // Get the preferred leverage for a pair, clamped to maxLeverage
  getLeverage: (exchangeId: string, pairSymbol: string, maxLeverage: number) => number;

  // Set the preferred leverage for a pair
  setLeverage: (exchangeId: string, pairSymbol: string, leverage: number) => void;
}

export const useLeveragePreferencesStore = create<LeveragePreferencesState>()(
  persist(
    (set, get) => ({
      preferences: {},

      getLeverage: (exchangeId, pairSymbol, maxLeverage) => {
        const key = `${exchangeId}:${pairSymbol}`;
        const stored = get().preferences[key];
        if (stored !== undefined) {
          // Clamp to maxLeverage in case it changed
          return Math.min(stored, maxLeverage);
        }
        // Default: 5x or maxLeverage if max < 5
        return Math.min(DEFAULT_LEVERAGE, maxLeverage);
      },

      setLeverage: (exchangeId, pairSymbol, leverage) => {
        const key = `${exchangeId}:${pairSymbol}`;
        set((state) => ({
          preferences: { ...state.preferences, [key]: leverage },
        }));
      },
    }),
    {
      name: "leverage-preferences",
      partialize: (state) => ({
        preferences: state.preferences,
      }),
    },
  ),
);
